import { createFileRoute } from "@tanstack/react-router";
import { FlhaDetailView } from "@/components/flha/flha-detail-view";

export const Route = createFileRoute("/_authenticated/flha/$flhaId")({
  component: FlhaDetailPage,
});

function FlhaDetailPage() {
  const { flhaId } = Route.useParams();
  const { user } = Route.useRouteContext();

  return <FlhaDetailView flhaId={flhaId} user={user} />;
}
